/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface UniversalJobHitSchema {
  id: string;
  /** @maxLength 255 */
  title: string;
  /** @maxLength 20 */
  status: string;
  project_id: string;
  /** @maxLength 255 */
  project_title: string;
  /** @maxLength 255 */
  employer_name: string;
  employer_website?: string | null;
  ats_connector_id?: string | null;
  candidate_count: number;
}
